// src/shared/utils/csvParser.ts
import Papa from 'papaparse';

export interface JointAndMuscleData {
    [key: string]: number; // название сустава или мышцы -> значение
}

export interface TimeFrame {
    time: number;
    data: JointAndMuscleData;
}

export const parseCSV = async (file: File | string): Promise<TimeFrame[]> => {
    return new Promise((resolve, reject) => {
        Papa.parse(file, {
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            delimiter: ';', // 🔹 важный момент для твоего CSV
            complete: (results: Papa.ParseResult<any>) => {
                const frames: TimeFrame[] = [];

                results.data.forEach((row: any) => {
                    // ищем колонку 'время'
                    const timeValue = row['время'];
                    if (timeValue === undefined || timeValue === null) return;

                    const time = parseFloat(timeValue);
                    const data: JointAndMuscleData = {};

                    Object.keys(row).forEach((key) => {
                        if (key === 'время') return; // пропускаем колонку времени
                        data[key] = parseFloat(row[key]);
                    });

                    frames.push({ time, data });
                });

                resolve(frames);
            },
            error: (error: Error) => {
                console.error('Ошибка парсинга CSV:', error);
                reject(error);
            },
        });
    });
};
